<div class="captcha-container">
  <mat-form-field appearance="fill" class="captcha-form-field">
    <mat-label>{{ "components.captcha.label" | translate }}</mat-label>
    <input
      matInput
      [value]="captchaVerificationDto?.answer"
      (input)="onValueChanges($any($event).target.value)"
    />
    <button mat-icon-button matSuffix (click)="loadCaptcha()">
      <mat-icon>refresh</mat-icon>
    </button>
    <mat-hint translate>components.captcha.hint</mat-hint>
  </mat-form-field>
  <div *ngIf="jpeg" class="captcha-image">
    <img [src]="jpeg | safe: 'url'" />
  </div>
</div>
